export type UnmatchedItem = {
  id: number
  connection_id: number
  connection_name: string
  connection_type: string
  party_kind: string
  name_snapshot: string
  email_snapshot: string | null
  organization_snapshot: string | null
  reason: string
  reason_detail: string | null
  waiting_rows: number
  status: string
  first_seen_at: string
  last_seen_at: string
  source_url: string | null
  resolved_by_name: string | null
  resolved_at: string | null
}
export type QueueResponse = {
  unmatched_items: UnmatchedItem[]
  connections: { id: number; display_name: string; connection_type: string }[]
}
export type SortColumn = 'waiting_rows' | 'last_seen' | 'name'
export const queuePath = '/api/v1/connection_unmatched_items'
export const reasonLabels: Record<string, string> = {
  no_match: 'No match',
  ambiguous: 'Ambiguous',
  archived_match: 'Archived match',
}
export function itemPath(row: UnmatchedItem) {
  return `/api/v1/connections/${row.connection_id}/unmatched_items/${row.id}`
}
